export const cardGridSx = (minWidth = 260, gap = 2) => ({
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: `repeat(auto-fill, minmax(${minWidth}px, 1fr))` },
  gap,
});

export const cardItemSx = (maxWidth = 340) => ({
  minWidth: 0,
  maxWidth: { sm: maxWidth },
});
